import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import ThreatBuilder from "@/pages/ThreatBuilder";
export const Route = createFileRoute("/threat-builder/")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><ThreatBuilder /></ProtectedRoute>) });
